import styled from 'styled-components';
import { MAIN_HEADER_HEIGHT } from 'src/utils/constants';

type WrapperProps = {
  hasMainHeader?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: absolute;
  left: 0;
  top: ${({ hasMainHeader }) => (hasMainHeader ? `${MAIN_HEADER_HEIGHT}` : 0)};
  right: 0;
  bottom: 0;
`;

Wrapper.displayName = 'Wrapper';
